import axios from "axios";

const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;

export const getSubscriptionPlans = async () => {
    try {
        const path = "subscription-plans";
        const response = await axios.get(dyrectApi + path);
        return response.data;
    } catch (error) {
        console.error("Error fetching subscription plans:", error);
        throw error;
    }
};

export const getSubscriptionInvoices = async () => {
    try {
        const userId = localStorage.getItem("user_id");
        const path = `subscription-invoices?userId=${userId}`;
        const response = await axios.get(dyrectApi + path);
        const data = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
        return data?.invoices ?? [];
    } catch (error) {
        console.error("Error fetching invoices:", error);
        throw error;
    }
};

export const cancelSubscription = async () => {
    try {
        const userId = localStorage.getItem("user_id");
        const path = "subscription-cancel";
        const response = await axios.post(dyrectApi + path, { userId });
        let data = response.data;
        
        if (typeof data === "string") {
            try {
                data = JSON.parse(data);
            } catch (_parseError) {
                console.error("Failed to parse cancel response:", data);
                throw new Error(data);
            }
        }
        
        if (data?.error) {
            throw new Error(data.error);
        }
        
        return data;
    } catch (error) {
        console.error("Error cancelling subscription:", error);
        throw error;
    }
};

export const getSubscriptionStatus = async () => {
    try {
        const userId = localStorage.getItem("user_id");
        const path = "subscription-status";
        const response = await axios.post(dyrectApi + path, { userId });
        let data = response.data;
        
        if (typeof data === "string") {
            try {
                data = JSON.parse(data);
            } catch (_parseError) {
                console.error("Failed to parse subscription status:", data);
                throw new Error(data);
            }
        }
        
        return data;
    } catch (error) {
        console.error("Error fetching subscription status:", error);
        throw error;
    }
};

export const startSubscriptionTrial = async (planId) => {
    try {
        const userId = localStorage.getItem("user_id");
        const profileData = JSON.parse(localStorage.getItem("user_profile_data") || "{}");
        const userEmail = profileData.Email || "";
        const path = "subscription-checkout";
        const response = await axios.post(dyrectApi + path, { planId, userId, userEmail });
        let data = response.data;

        if (typeof data === "string") {
            try {
                data = JSON.parse(data);
            } catch (_parseError) {
                console.error("Failed to parse checkout response:", data);
                throw new Error(data);
            }
        }

        if (data?.error) {
            throw new Error(data.error);
        }

        return data;
    } catch (error) {
        console.error("Error starting subscription trial:", error);
        throw error;
    }
};

export const updatePaymentMethod = async () => {
    try {
        const userId = localStorage.getItem("user_id");
        const path = "subscription-update-payment-method";
        const response = await axios.post(dyrectApi + path, { userId });
        let data = response.data;

        if (typeof data === "string") {
            try {
                data = JSON.parse(data);
            } catch (_parseError) {
                console.error("Failed to parse payment method response:", data);
                throw new Error(data);
            }
        }

        if (data?.error) {
            throw new Error(data.error);
        }

        return data;
    } catch (error) {
        console.error("Error updating payment method:", error);
        throw error;
    }
};
